/* Edits the state whenever siteId is changed */

export default function sourceRevision(state = [], action) {
	switch (action.type) {
	case 'SOURCE_REVISION' :
		return action.rev;

	default:
		return state;
	}
}
